module.exports = __webpack_public_path__ + "img/zerossl.90930b54.svg";